import { useQuery } from '@tanstack/react-query'
import { DailyRewardsQueryParams, dailyRewardsQueryOptions } from '@/layouts/engagement/api'
import { useGenerateCompanyPath } from '@/libs'

export const useDailyRewards = (params?: DailyRewardsQueryParams) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { isLoading, data } = useQuery(dailyRewardsQueryOptions(companyId, gameId, params))
  return { isLoading, data }
}
